import Box from '@mui/material/Box';
import { type UseFormRegisterReturn } from 'react-hook-form';

/**
 * Bot trap. Hidden from sight and from screen readers, and never focusable, so
 * no real visitor fills it in. A filled value is recorded as spam server-side.
 *
 * The id, DOM name and label are deliberately generic: browser and password-manager
 * autofill match on words like "company" or "website" and fill the field for real
 * visitors, whose orders the server then silently discards as spam. The DOM name
 * differs from the form key, so changes are forwarded to react-hook-form by key.
 */
export function HoneypotField({ field }: { field: UseFormRegisterReturn }) {
  return (
    <Box
      aria-hidden
      sx={{ position: 'absolute', left: '-9999px', width: 1, height: 1, overflow: 'hidden' }}
    >
      <label htmlFor="hp_field">Leave this field empty</label>
      <input
        type="text"
        tabIndex={-1}
        autoComplete="off"
        data-lpignore="true"
        data-1p-ignore
        data-form-type="other"
        ref={field.ref}
        id="hp_field"
        name="hp_field"
        onBlur={field.onBlur}
        onChange={(e) => field.onChange({ type: 'change', target: { name: field.name, value: e.target.value } })}
      />
    </Box>
  );
}
